export const GALLERY = [
  {
    images: [
      'https://plus.unsplash.com/premium_photo-1723901831135-782c98d8d8e0?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
    ],
    address: 'Sonnenweg 15, 8810 Horgen, Switzerland',
    beds: 3,
    baths: 3,
    sqrFeet: 125,
    price: 5200,
    matchScore: 92,
    matchedAt: '2025-05-19T08:30:00Z',
    listedAt: '2025-05-17T09:00:00Z'
  },
  {
    images: [
      'https://images.unsplash.com/photo-1523755231516-e43fd2e8dca5?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
    ],
    address: 'Seestrasse 42, 8810 Horgen, Switzerland',
    beds: 3,
    baths: 3,
    sqrFeet: 120,
    price: 4800,
    matchScore: 88,
    matchedAt: '2025-05-19T07:00:00Z',
    listedAt: '2025-05-16T12:00:00Z'
  },
  {
    images: [
      'https://plus.unsplash.com/premium_photo-1663126298656-33616be83c32?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
    ],
    address: 'Blumenweg 8, 8810 Horgen, Switzerland',
    beds: 3,
    baths: 3,
    sqrFeet: 130,
    price: 5500,
    matchScore: 95,
    matchedAt: '2025-05-19T08:00:00Z',
    listedAt: '2025-05-18T15:00:00Z'
  },
  {
    images: [
      'https://images.unsplash.com/photo-1554995207-c18c203602cb?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
    ],
    address: 'Kirchgasse 19, 8810 Horgen, Switzerland',
    beds: 3,
    baths: 3,
    sqrFeet: 120,
    price: 5000,
    matchScore: 90,
    matchedAt: '2025-05-19T06:30:00Z',
    listedAt: '2025-05-15T10:00:00Z'
  }
];
